import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminApplicationsListComponent } from '../../lists/admin-applications-list/admin-applications-list.component';

@Component({
  selector: 'app-admin-applications',
  standalone: true,
  templateUrl: './admin-applications.component.html',
  styleUrls: ['./admin-applications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminApplicationsListComponent],
})
export class AdminApplicationsComponent {}
